import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { getSelectedTableView, getInboxClassificationFilterForTable } from 'owa-mail-list-store';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { isInboxPlusEnabled } from 'owa-mail-inbox-plus-store/lib/selectors/inboxPlusFlightUtil';

export const inboxClassificationFilterRestriction = (
    inboxClassificationFilterList: InboxClassificationFilter[]
) => () => {
    // Check if inboxClassificationFilter restrictions are to be applied
    const tableView: TableView = getSelectedTableView();
    return (
        isInboxPlusEnabled() &&
        inboxClassificationFilterList.includes(getInboxClassificationFilterForTable(tableView.id))
    );
};
